// extracted by mini-css-extract-plugin
export var card = "_nf-0";
export var content = "_nf-2";
export var icon = "_nf-1";